'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');



//////////////////
// WEBPACK FOOTER
// ./node_modules/hash.js/lib/hash/sha.js
// module id = NCTB
// module chunks = 2